<div class=" title_con ">
  <div>
  <h2 class="title">{{title_page}}</h2>
    </div>
  <div>
    <mat-radio-group (change)="appChange($event)" aria-label="Select an option" *ngIf="this.reason =='fordealerdata'">
      <mat-radio-button value="all" checked>All</mat-radio-button>
      <mat-radio-button value="anc">ANC</mat-radio-button>
      <mat-radio-button value="auc">AUC</mat-radio-button>
    </mat-radio-group>
  </div>
  <div>



    <mat-form-field appearance="standard" class="filter_inp_seed_key_tbl" *ngIf="clients!=undefined">
      <mat-label>Filter by client</mat-label>
      <mat-select [(ngModel)]="selectClient" (selectionChange)="applyFilter($event)">
        <mat-option value="0">All</mat-option>
        <mat-option *ngFor="let cl of clients" [value]="cl.clientID">
          {{cl.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    &nbsp;
    <button mat-mini-fab color="accent" (click)="addseed()" *ngIf="this.reason =='noClientseed' || this.reason =='seed'">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<table mat-table [dataSource]="dataSource" class="table_seed" *ngIf="dataSource.data.length > 0">

  <ng-container matColumnDef="chk" sticky>
    <th mat-header-cell *matHeaderCellDef>  <mat-checkbox [(ngModel)]="mainChecked" (change)="selectAll($event)"></mat-checkbox> </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox [(ngModel)]="element.selected" [id]="element.configAdSeedID" (change)="changeStatus($event,element.configAdSeedID)"></mat-checkbox>
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="seedText" sticky>
    <th mat-header-cell *matHeaderCellDef> Seed Text </th>
    <td mat-cell *matCellDef="let element">
      <mat-form-field appearance="standard" class="form_fieldSeed">
        <input matInput [(ngModel)]="element.seedText">
      </mat-form-field>
    </td>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="group_Id">
    <th mat-header-cell *matHeaderCellDef> Theme Name </th>
    <td mat-cell *matCellDef="let element">
      {{element.configAdGroupCode}}
    </td>
  </ng-container>

  <ng-container matColumnDef="dealers">
    <th mat-header-cell *matHeaderCellDef> Dealer Name </th>
    <td mat-cell *matCellDef="let element">
      {{element.dealerName}}
    </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="clientId">
    <th mat-header-cell *matHeaderCellDef> Client Name </th>
    <td mat-cell *matCellDef="let element">
      {{element.clientName}}
    </td>
  </ng-container>
  <ng-container matColumnDef="isBroard">
    <th mat-header-cell *matHeaderCellDef>  Broad </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox [(ngModel)]="element.isBroad"></mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="isPhrase">
    <th mat-header-cell *matHeaderCellDef>  Phrase </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox [(ngModel)]="element.isPhrase"></mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="isExact">
    <th mat-header-cell *matHeaderCellDef>  Exact </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox [(ngModel)]="element.isExact"></mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="broad_cpc">
    <th mat-header-cell *matHeaderCellDef> Broad CPC </th>
    <td mat-cell *matCellDef="let element">
      <mat-form-field appearance="standard" class="form_fieldSeed">
        <input matInput [(ngModel)]="element.broadCpc">
      </mat-form-field>
    </td>
  </ng-container>
  <ng-container matColumnDef="phrase_CPc">
    <th mat-header-cell *matHeaderCellDef> Phrase CPC </th>
    <td mat-cell *matCellDef="let element">
      <mat-form-field appearance="standard" class="form_fieldSeed">
        <input matInput [(ngModel)]="element.phraseCpc">
      </mat-form-field>
    </td>
  </ng-container>
  <ng-container matColumnDef="exactCPC">
    <th mat-header-cell *matHeaderCellDef> Exact CPC </th>
    <td mat-cell *matCellDef="let element">
      <mat-form-field appearance="standard" class="form_fieldSeed">
        <input matInput [(ngModel)]="element.exactCpc">
      </mat-form-field>
    </td>
  </ng-container>

  <ng-container matColumnDef="save">
    <th mat-header-cell *matHeaderCellDef> Save </th>
    <td mat-cell *matCellDef="let element">
      <button mat-raised-button color="primary" (click)="saveCaller(element)" [disabled]="!IsAnychanged(element)">Save</button>
    </td>
  </ng-container>
  <ng-container matColumnDef="del">
    <th mat-header-cell *matHeaderCellDef> Delete </th>
    <td mat-cell *matCellDef="let element">
      <button mat-raised-button color="accent" (click)="deleteSeedCOnf(element.configAdSeedID)">Delete</button>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator *ngIf="dataSource.data.length > 0" (page)=" handlePage()"  [pageSizeOptions]="[50,25,5, 10, 20,100]"
               showFirstLastButtons
               aria-label="Select page of periodic elements">
</mat-paginator>

<div class="container" *ngIf="dataSource.data.length == 0">
No data found
</div>
